<div class="col p-0">
    <div class="alert alert-warning w-100">
        {{'CONFIGURE.DATA_TEMP_READ_ONLY' | translate }}
    </div>
    <div class="wardSelectInstitution">
        <app-bd-search (searchTextChanged)="onSearchTextChanged($event)"></app-bd-search>
    </div>
    <div class="col-12 static-card">
        <bd-light-table [gridData]="gridData || [] | search:searchText:['categoryName']" 
        [pageInfo]="pageInfo" [fields]="fields" 
        (handlerData)="handlerData($event)"></bd-light-table>
    </div>
    <!-- <lib-ph-bhp-grid [gridData]="gridData | search:searchText:['categoryName']" [fields]="fields" [gridGroupable]="false" [gridEditable]="false" 
    (handlerData)="handlerData($event)" [pageInfo]="pageInfo" [formGroupModel]="professionalCategoryModelGridEdit"></lib-ph-bhp-grid> -->
</div>




<ng-template #delmodal>
    <div class="modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar>
        <p>{{ 'ERROR_MESSAGES.CONFIRMATION.DELETE.RECORD' | translate }}</p>
    </div>
    <div class="modal-footer">
        <div class="container-fluid">
            <div class="row">
                <div class="col my-3 justify-content-center align-items-center d-flex">
                    <button (click)="modalRef.hide()" class="btn btn-cancel-bordered-bd mr-4">{{ 'BUTTON.CANCEL' | translate }}</button>
                    <button (click)="delete();modalRef.hide()" class="btn btn-continue-bordered-bd">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
